// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

import { sprintf } from '@wordpress/i18n';

import { renderCantEditDialog, restCall } from '../common/utilities.js';

// Import utilities
const {
	isEmpty,
	isDefined,
	addParametersUTM
} = _uo.utility;

import RecipeNotices from '../recipe/notices.js';

import Field from '../field';

import Triggers from '@builder-legacy/item/triggers';
import Actions from '@builder-legacy/item/actions';

class Publish {
	constructor() {
		// Get metabox element
		this.elements = {
			metabox: $( '#uo-automator-publish-metabox' ),
			timesPerUser: {
				editLink: null,
				hiddenBox: null,
				saveButton: null,
				cancelButton: null,
				endPoint: 'recipe_completions_allowed',
			},
			timesPerRecipe: {
				editLink: null,
				hiddenBox: null,
				saveButton: null,
				cancelButton: null,
				endPoint: 'recipe_max_completions_allowed',
			},
			toggle: null,
		};

		// Create new metabox
		this.createMetabox();
	}

	createMetabox() {
		const container = $( '<div/>', { id: 'uap-publish-metabox' } ),
			content = $( '<div/>', { class: 'metabox__content' } ),
			footer = $( '<div/>', { class: 'metabox__footer' } );

		// Check if we have to add the times per user row
		if ( UncannyAutomator._recipe.recipe_type != 'anonymous' ) {
			// Times per user row
			const timesRow = $( '<div/>', { class: 'publish-row' } ),
				timesRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
				timesRowIconBox = $( '<span/>', { class: 'publish-row__icon' } ),
				timesRowIcon = $( '<uo-icon/>', { id: 'repeat' } ),
				timesRowName = $( '<span/>', { class: 'publish-row__name' } ).text(
					UncannyAutomator._core.i18n.publish.timesPerUser
				);

			// Change value of numbers of times from -1 to empty
			UncannyAutomator._recipe.miscellaneous.limit_per_user =
				UncannyAutomator._recipe.miscellaneous.limit_per_user == -1 ? '' : UncannyAutomator._recipe.miscellaneous.limit_per_user;
			const timesValue = isEmpty( UncannyAutomator._recipe.miscellaneous.limit_per_user )
				? UncannyAutomator._core.i18n.publish.unlimited
				: UncannyAutomator._recipe.miscellaneous.limit_per_user;

			const timesRowValue = $( '<span/>', { class: 'publish-row__value' } ).text( timesValue ),
				timesRowEdit = $( '<span/>', { class: 'publish-row__edit' } ).text( UncannyAutomator._core.i18n.edit ),
				timesRowHidden = $( '<div/>', { class: 'publish-row__hidden' } ),
				timesRowHiddenBox = $( '<div/>', { class: 'publish-row__settings' } );

			this.elements.timesPerUser.editLink = timesRowEdit;
			this.elements.timesPerUser.hiddenBox = timesRowHidden;

			const timesRowField = new Field(
				'int',
				{
					currentValue: UncannyAutomator._recipe.miscellaneous.limit_per_user,
					description: UncannyAutomator._core.i18n.publish.leaveEmpty,
					placeholder: UncannyAutomator._core.i18n.publish.unlimited,
				},
				true,
				( value ) => {
					// Custom validation function
					// Create response object
					const response = {
						isValid: false,
						message: '',
					};

					// Check if the number is 1 or bigger
					if ( value >= 1 ) {
						response.isValid = true;
					} else {
						response.message = UncannyAutomator._core.i18n.publish.oneOrBigger;
					}

					// Return response
					return response;
				}
			);

			this.timesField = timesRowField;

			const timesRowButtons = $( '<div/>', { class: 'publish-row__buttons' } ),
				timesRowSaveBtn = $( '<div/>', { class: 'uap-btn uap-btn--primary' } ).text(
					UncannyAutomator._core.i18n.save
				),
				timesRowCancelBtn = $( '<div/>', { class: 'uap-btn uap-btn--secondary' } ).text(
					UncannyAutomator._core.i18n.cancel
				);

			this.elements.timesPerUser.saveButton = timesRowSaveBtn;
			this.elements.timesPerUser.cancelButton = timesRowCancelBtn;

			timesRowButtons.append( timesRowSaveBtn );
			timesRowButtons.append( timesRowCancelBtn );

			timesRowHiddenBox.append( timesRowField.getFormElement() );
			timesRowHiddenBox.append( timesRowButtons );
			timesRowHidden.append( timesRowHiddenBox );

			timesRowIconBox.append( timesRowIcon );
			timesRowVisible.append( timesRowIconBox );
			timesRowVisible.append( timesRowName );
			timesRowVisible.append( timesRowValue );
			timesRowVisible.append( timesRowEdit );

			timesRow.append( timesRowVisible );
			timesRow.append( timesRowHidden );

			content.append( timesRow );
		}

		const timesPerRecipe = this.timesPerRecipe();
		content.append( timesPerRecipe );

		// Recipe type
		const recipeTypeRow = $( '<div/>', { class: 'publish-row' } ),
			recipeTypeRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
			recipeTypeRowIconBox = $( '<span/>', { class: 'publish-row__icon' } ),
			recipeTypeRowIcon = $( '<uo-icon/>', { id: 'user' } ),
			recipeTypeRowName = $( '<span/>', { class: 'publish-row__name' } ).text(
				UncannyAutomator._core.i18n.publish.recipeType
			),
			recipeTypeRowValue = $( '<span/>', { class: 'publish-row__value' } ),
			recipeTypeLearnMore = $( `
				<a href="${ addParametersUTM( 'https://automatorplugin.com/knowledge-base/creating-a-recipe/', {
					medium: 'publish_metabox',
					content: 'recipe_type_question_icon',
				} ) }" class="publish-row__learn-more" target="_blank"><uo-icon id="question-circle"></uo-icon></a>
			` );

		if ( UncannyAutomator._recipe.recipe_type == 'user' ) {
			recipeTypeRowValue.text( UncannyAutomator._core.i18n.recipeType.userRecipeName );
		}

		if ( UncannyAutomator._recipe.recipe_type == 'anonymous' ) {
			recipeTypeRowValue.text( UncannyAutomator._core.i18n.recipeType.everyoneRecipeName );
		}

		recipeTypeRowIconBox.append( recipeTypeRowIcon );
		recipeTypeRowVisible.append( recipeTypeRowIconBox );
		recipeTypeRowVisible.append( recipeTypeRowName );
		recipeTypeRowVisible.append( recipeTypeRowValue );
		recipeTypeRowVisible.append( recipeTypeLearnMore );
		recipeTypeRow.append( recipeTypeRowVisible );

		content.append( recipeTypeRow );

		// Created on row
		const createdRow = $( '<div/>', { class: 'publish-row' } ),
			createdRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
			createdRowIconBox = $( '<span/>', { class: 'publish-row__icon' } ),
			createdRowIcon = $( '<uo-icon/>', { id: 'calendar' } ),
			createdRowName = $( '<span/>', { class: 'publish-row__name' } ).text(
				UncannyAutomator._core.i18n.publish.createdOn
			),
			createdRowValue = $( '<span/>', { class: 'publish-row__value' } ).text(
				UncannyAutomator._recipe.miscellaneous.created_on_date
			);

		createdRowIconBox.append( createdRowIcon );
		createdRowVisible.append( createdRowIconBox );
		createdRowVisible.append( createdRowName );
		createdRowVisible.append( createdRowValue );
		createdRow.append( createdRowVisible );

		content.append( createdRow );

		// Recipe runs row
		let recipeRunTimeVal = UncannyAutomator._recipe.stats.total_runs;
		let recipeRunTimeUrlVal = $( '<a/>', {
			class: 'publish-row__recipe-runs',
			target: '_blank',
			href: UncannyAutomator._recipe.miscellaneous.url_logs.replace( /&amp;/g, '&' ),
		} ).text( UncannyAutomator._core.i18n.viewLogs );

		const recipeRunTimesRow = $( '<div/>', { class: 'publish-row' } ),
			recipeRunTimesRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
			recipeRunTimesRowIconBox = $( '<span/>', { class: 'publish-row__icon' } ),
			recipeRunTimesRowIcon = $( '<uo-icon/>', { id: 'repeat' } ),
			recipeRunTimesRowName = $( '<span/>', { class: 'publish-row__name' } ).text(
				UncannyAutomator._core.i18n.publish.recipeRunTimes
			);

		recipeRunTimesRowIconBox.append( recipeRunTimesRowIcon );
		recipeRunTimesRowVisible.append( recipeRunTimesRowIconBox );
		recipeRunTimesRowVisible.append( recipeRunTimesRowName );
		recipeRunTimesRowVisible.append( $( '<span/>', { class: 'publish-row__value' } ).text( recipeRunTimeVal ) );
		recipeRunTimesRowVisible.append( recipeRunTimeUrlVal );
		recipeRunTimesRow.append( recipeRunTimesRowVisible );

		content.append( recipeRunTimesRow );

		// Copy/Duplicate Recipe
		const copyRecipeRow = $( '<div/>', { class: 'publish-row' } ),
			copyRecipeRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
			copyRecipeRowName = $( '<a/>', {
				class: 'publish-row__copy-to-draft button button-secondary',
				href: UncannyAutomator._recipe.miscellaneous.url_duplicate_recipe.replace( /&amp;/g, '&' ),
			} ).text( UncannyAutomator._core.i18n.publish.copyRecipe );

		copyRecipeRowVisible.append( copyRecipeRowName );
		copyRecipeRow.append( copyRecipeRowVisible );

		content.append( copyRecipeRow );

		const footerRow = $( '<div/>', { class: 'publish-footer__row uap-clear' } ),
			footerRowLeft = $( '<div/>', { class: 'publish-footer__left' } ),
			footerMoveToDraft = $( '<a/>', {
				class: 'publish-footer__move-to-draft',
				href: UncannyAutomator._recipe.miscellaneous.url_trash_recipe.replace( /&amp;/g, '&' ),
			} ).text( UncannyAutomator._core.i18n.proOnly.moveToTrash ),
			footerRowRight = $( '<div/>', { class: 'publish-footer__right' } );

		const recipeStatusToggle = new Field( 'checkbox', {
			color: 'gutenberg',
			align: 'right',
			toggle: {
				on: UncannyAutomator._core.i18n.status.liveRecipe,
				off: UncannyAutomator._core.i18n.status.draftRecipe,
			},
			currentValue: UncannyAutomator._recipe.is_recipe_on,
		} );

		// Save toggle Field in main object
		UncannyAutomator.recipe.publish.statusToggle = recipeStatusToggle;

		const recipeStatusToggleDOM = recipeStatusToggle.getFormElement();
		this.recipeStatusToggle = recipeStatusToggle;

		this.elements.toggle = recipeStatusToggleDOM;

		footerRowLeft.append( footerMoveToDraft );
		footerRow.append( footerRowLeft );
		footerRow.append( footerRowRight );

		// Check if it has the "Run now" trigger and render a button instead of the toggle
		if ( UncannyAutomator._recipe.miscellaneous.has_run_now ) {
			// Run now button
			const $runNowBtn = document.createElement( 'uo-button' );
			$runNowBtn.innerText = UncannyAutomator._core.i18n.runNow.runNowButtonLabel;
			$runNowBtn.size = 'small';

			// Add click event
			$runNowBtn.addEventListener( 'click', () => {
				const runRecipe = () => {
					// Set loading animation
					$runNowBtn.loading = true;

					// Do call to run recipe
					UncannyAutomator._core.recipe.runRecipe()
						.then( response => {
							renderCantEditDialog();
						} );
				}

				// Check if the recipe is published
				if ( ! UncannyAutomator._recipe.is_recipe_on ) {
					// Set loading animation
					$runNowBtn.loading = true;

					// Set recipe as published
					this.setRecipeStatus( true, 'publish', runRecipe, () => {
						$runNowBtn.loading = false;
					} );
				} else {
					runRecipe();
				}
			} );
			
			// Append button to the DOM
			footerRowRight.append( $runNowBtn );
		} else {
			footerRowRight.append( recipeStatusToggleDOM );
		}

		footer.append( footerRow );

		// Append main elements to the metabox
		container.append( content );
		container.append( footer );

		// Render metabox
		this.elements.metabox.html( container );

		// Render errors
		new RecipeNotices();

		// Bind
		this.bind();

		// Validate status
		this.validateStatus();
	}

	timesPerRecipe() {
		// Times per recipe row
		const timesRecipeRow = $( '<div/>', { class: 'publish-row' } ),
			timesRecipeRowVisible = $( '<div/>', { class: 'publish-row__visible' } ),
			timesRecipeRowIconBox = $( '<span/>', { class: 'publish-row__icon' } ),
			timesRecipeRowIcon = $( '<uo-icon/>', { id: 'hashtag' } ),
			timesRecipeRowName = $( '<span/>', { class: 'publish-row__name' } ).text(
				UncannyAutomator._core.i18n.publish.timesPerRecipe
			);

		// Change value of numbers of times from -1 to empty
		UncannyAutomator._recipe.miscellaneous.limit_per_recipe =
			UncannyAutomator._recipe.miscellaneous.limit_per_recipe == -1 ? '' : UncannyAutomator._recipe.miscellaneous.limit_per_recipe;
		const timesRecipeValue = isEmpty( UncannyAutomator._recipe.miscellaneous.limit_per_recipe )
			? UncannyAutomator._core.i18n.publish.unlimited
			: UncannyAutomator._recipe.miscellaneous.limit_per_recipe;

		const timesRecipeRowValue = $( '<span/>', { class: 'publish-row__value' } ).text( timesRecipeValue ),
			timesRecipeRowEdit = $( '<span/>', { class: 'publish-row__edit' } ).text( UncannyAutomator._core.i18n.edit ),
			timesRecipeRowHidden = $( '<div/>', { class: 'publish-row__hidden' } ),
			timesRecipeRowHiddenBox = $( '<div/>', { class: 'publish-row__settings' } );

		this.elements.timesPerRecipe.editLink = timesRecipeRowEdit;
		this.elements.timesPerRecipe.hiddenBox = timesRecipeRowHidden;

		const timesRecipeRowField = new Field(
			'int',
			{
				currentValue: UncannyAutomator._recipe.miscellaneous.limit_per_recipe,
				description: UncannyAutomator._core.i18n.publish.leaveEmpty,
				placeholder: UncannyAutomator._core.i18n.publish.unlimited,
			},
			true,
			( value ) => {
				// Custom validation function
				// Create response object
				const response = {
					isValid: false,
					message: '',
				};

				// Check if the number is 1 or bigger
				if ( value >= 1 ) {
					response.isValid = true;
				} else {
					response.message = UncannyAutomator._core.i18n.publish.oneOrBigger;
				}

				// Return response
				return response;
			}
		);

		this.timesRecipeField = timesRecipeRowField;

		const timesRecipeRowButtons = $( '<div/>', { class: 'publish-row__buttons' } ),
			timesRecipeRowSaveBtn = $( '<div/>', { class: 'uap-btn uap-btn--primary' } ).text(
				UncannyAutomator._core.i18n.save
			),
			timesRecipeRowCancelBtn = $( '<div/>', { class: 'uap-btn uap-btn--secondary' } ).text(
				UncannyAutomator._core.i18n.cancel
			);

		this.elements.timesPerRecipe.saveButton = timesRecipeRowSaveBtn;
		this.elements.timesPerRecipe.cancelButton = timesRecipeRowCancelBtn;

		timesRecipeRowButtons.append( timesRecipeRowSaveBtn );
		timesRecipeRowButtons.append( timesRecipeRowCancelBtn );

		timesRecipeRowHiddenBox.append( timesRecipeRowField.getFormElement() );
		timesRecipeRowHiddenBox.append( timesRecipeRowButtons );
		timesRecipeRowHidden.append( timesRecipeRowHiddenBox );

		timesRecipeRowIconBox.append( timesRecipeRowIcon );
		timesRecipeRowVisible.append( timesRecipeRowIconBox );
		timesRecipeRowVisible.append( timesRecipeRowName );
		timesRecipeRowVisible.append( timesRecipeRowValue );
		timesRecipeRowVisible.append( timesRecipeRowEdit );

		timesRecipeRow.append( timesRecipeRowVisible );
		timesRecipeRow.append( timesRecipeRowHidden );

		return timesRecipeRow;
	}

	validateStatus() {
		// We're going to use this method to check if the recipe is live but it's invalid
		if ( UncannyAutomator._recipe.is_recipe_on && ! UncannyAutomator.recipe.isValid ) {
			// Make Draft
			UncannyAutomator.recipe.publish.statusToggle.setValue( false );
		}
	}

	validateTimesPerFields( $element, $fieldValue, $timeField ) {
		// Times per user, click on "Edit"
		$element.editLink.on( 'click', () => {
			// Slide toggle
			$element.hiddenBox.slideToggle( 300 );
		} );

		// Times per user, click on "Cancel"
		$element.cancelButton.on( 'click', () => {
			// Slide toggle
			$element.hiddenBox.slideToggle( 300, () => {
				// Reset UI
				new Publish();
			} );
		} );

		// Timer per user, click on "Save"
		$element.saveButton.on( 'click', () => {
			// Validate input
			const validation = $timeField.validate();

			// Check if it's valid. Otherwise do nothing. Field.js will show an error
			if ( validation.isValid ) {
				// Add loading class to save button
				$element.saveButton.addClass( 'uap-btn--loading uap-btn--disabled' );

				// Get value. We have to check if it's empty and change it to -1
				let numberOfTimes = $timeField.getValue();

				if ( isEmpty( numberOfTimes ) ) {
					numberOfTimes = -1;
				}

				restCall(
					$element.endPoint,
					{
						// eslint-disable-next-line camelcase
						post_ID: UncannyAutomator._recipe.recipe_id,
						// eslint-disable-next-line camelcase
						recipe_completions_allowed: numberOfTimes,
					},
					() => {
						// Update JS object
						if ( $element.endPoint == 'recipe_completions_allowed' ) {
							UncannyAutomator._recipe.miscellaneous.limit_per_user = numberOfTimes;
						} else {
							UncannyAutomator._recipe.miscellaneous.limit_per_recipe = numberOfTimes;
						}
						// $fieldValue = numberOfTimes;
						// Slide toggle fields container and refresh the Publish UI
						$element.hiddenBox.slideToggle( 300, () => {
							// Reset UI
							new Publish();
							new Actions();
							new Triggers();
						} );
					},
					() => {
						// Output if the developer mode is enabled
						if ( UncannyAutomator._site.has_debug_enabled ) {
							// eslint-disable-next-line no-console
							console.error( "Couldn't save times per user" );
						}

						// Revert changes
						$timeField.setValue( $fieldValue );

						// Remove the loading class to save button
						$element.saveButton.removeClass( 'uap-btn--loading uap-btn--disabled' );
					}
				);
			}
		} );

		// Get field element and bind 'keyup'
		$timeField.getField().on( 'keyup', ( event ) => {
			// Check if it's an enter
			if ( event.keyCode == 13 ) {
				// Trigger a click on the Save Button
				$element.saveButton.trigger( 'click' );
			}
		} );
	}

	bind() {
		// Check if we have to add the event listeners to the "times per user" row
		if ( UncannyAutomator._recipe.recipe_type != 'anonymous' ) {
			// Times per user, click on "Edit"
			this.validateTimesPerFields(
				this.elements.timesPerUser,
				UncannyAutomator._recipe.miscellaneous.limit_per_user,
				this.timesField
			);
		}

		// Validate Recipe max times
		this.validateTimesPerFields(
			this.elements.timesPerRecipe,
			UncannyAutomator._recipe.miscellaneous.limit_per_recipe,
			this.timesRecipeField
		);

		// Status change
		this.elements.toggle.on( 'automator:field:change', () => {
			// Set post status
			const makeLive = this.recipeStatusToggle.getValue(),
			      postStatus = makeLive ? 'publish' : 'draft';

			this.setRecipeStatus( makeLive, postStatus );
		} );
	}

	/**
	 * Sets the recipe status
	 * 
	 * @param {String} postStatus The status to set. It can be "publish" or "draft"
	 */
	setRecipeStatus( makeLive, postStatus, onSuccess = null, onError = null ) {
		const canMakeLive = true;

		// Set loading status
		this.recipeStatusToggle.startLoadingAnimation();

		// Check if the user is trying to make the recipe live
		if ( canMakeLive && ( ! makeLive || ( makeLive && UncannyAutomator.recipe.isValid ) ) ) {
			restCall(
				'change_post_status',
				{
					recipe_id: UncannyAutomator._recipe.recipe_id,
					// eslint-disable-next-line camelcase
					post_ID: UncannyAutomator._recipe.recipe_id,
					// eslint-disable-next-line camelcase
					post_status: postStatus,
				},
				() => {
					// Update main object
					UncannyAutomator._recipe.is_recipe_on = makeLive;

					// Reset the UI
					new Publish();
					new Actions();
					new Triggers();

					if ( isDefined( onSuccess ) ) {
						onSuccess();
					}

					// Send custom event to the document
					document.dispatchEvent( new CustomEvent( 'uap/builder/legacy/recipe-changed-status', {
						detail: {
							isRecipeOn: UncannyAutomator._recipe.is_recipe_on,
						}
					} ) );
				},
				() => {
					// Output if the developer mode is enabled
					if ( UncannyAutomator._site.has_debug_enabled ) {
						// eslint-disable-next-line no-console
						console.error( "Couldn't set the recipe status" );
					}

					if ( isDefined( onError ) ) {
						onError();
					}

					// Revert user change
					setTimeout( () => {
						// Stop loading animation
						this.recipeStatusToggle.stopLoadingAnimation();

						// Revert value
						this.recipeStatusToggle.setValue( false, false );
					}, 1000 );
				}
			);
		} else {
			if ( ! canMakeLive ) {
				// Set error message
				UncannyAutomator.recipe.message.error = sprintf(
					UncannyAutomator._core.i18n.proOnly.proToPublish,
					UncannyAutomator._core.i18n.uncannyAutomatorPro,
				);
			}

			// Set error mode
			UncannyAutomator.recipe.errorMode = true;

			// Show error
			new RecipeNotices();

			// Revert user change
			setTimeout( () => {
				// Stop loading animation
				this.recipeStatusToggle.stopLoadingAnimation();

				// Revert value
				this.recipeStatusToggle.setValue( false, false );
			}, 1000 );
		}
	}
}

export default Publish;
